
import { TutorialStep } from "@/components/tutorial/TutorialSpotlight";

// Export the tutorial steps for the Home page
export const shoppingListTutorial: TutorialStep[] = [
  {
    target: ".tutorial-target-list-card",
    title: "Le tue Liste",
    content: "Qui trovi tutte le tue liste della spesa. Puoi creare nuove liste o accedere a quelle esistenti.",
  },
  {
    target: ".tutorial-target-list-options",
    title: "Opzioni della Lista",
    content: "Tocca questo pulsante per accedere alle opzioni della lista. Qui puoi modificare il nome, eliminare la lista o cambiarne lo sfondo."
  }
];

